@import (reference) '../../../constants/spacing.module.less';

.order-details-selected-content-header {
  padding: @space-16 @space-0;
  position: sticky;
  top: 0;
  background: inherit;
}
